import { BreakpointObserver } from '@angular/cdk/layout';
import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Menu } from '@app/models/menu.model';
import { Profile } from '@app/models/profile.model';
import { WebviewService } from '@app/services/webview.service';
import { StorageEnum, WebviewLandingHome } from '@app/shared/enum/storage';
import { AuthSelectors } from '@app/store/auth/auth.selectors';
import { SelectUser } from '@app/store/data/data.classes';
import { SetAliasId } from '@app/store/setting/setting.classes';
import { SettingSelectors } from '@app/store/setting/setting.selectors';
import { SettingStateModel } from '@app/store/setting/setting.state';
import { NoteTitleInputParams } from '@care-connect-japan/ckweblib/lib/data/schema/params/library-params';
import { Select, Store } from '@ngxs/store';
import { fromEvent, Observable, Subject, takeUntil, filter, map } from 'rxjs';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
})
export class MainLayoutComponent implements OnInit, OnDestroy, AfterViewInit {
  // pdf render
  // @ViewChild('pdf') pdfComponent!: ElementRef;
  // @ViewChildren('libnoterender') libNoteRender = new QueryList<LibNoteTitleComponent>();
  //
  @Select(AuthSelectors.profile) profile$!: Observable<Profile>;
  isTablet$: Observable<boolean>;
  notiLoading: boolean = false;
  private onDestory$: Subject<void>;
  private onRouteCheck$: Subject<void>;
  renderPDFData?: NoteTitleInputParams | null;

  get isDev() {
    return sessionStorage.getItem('dev') == '1'
  }

  // get menu() {
  //   const menuList = this.store.selectSnapshot(SettingState.menuList);
  //   const getMenu = this.getMenu(menuList);
  //   return getMenu(this.router.url);
  // }

  constructor(
    private breakpointObserver: BreakpointObserver,
    private route: ActivatedRoute,
    private router: Router,
    private store: Store,
    private webviewService: WebviewService,
  ) {

    this.isTablet$ = this.breakpointObserver
      .observe('(min-width: 768px)')
      .pipe(map((state: any) => state.matches));
    this.onDestory$ = new Subject();
    this.onRouteCheck$ = new Subject();
  }

  async ngAfterViewInit(): Promise<void> {
    this.webviewService.kidsRenderDone();
    // this.careConneService.renderPDF$.subscribe((data: any) => {
    //   this.renderPDFData = data;
    //   this.cd.detectChanges();
    // })
    // this.webviewService.triggerSpinnerMobile(false);
    // await this.careConneService.iniPDFComponent(this.pdfComponent, this.libNoteRender);
  }


  ngOnInit(): void {
    this.store.dispatch(new SelectUser());
    this.settingEvent();
    this.router.events
      .pipe(filter((event: any) => event instanceof NavigationEnd))
      .subscribe((_: any) => {
        this.route.firstChild?.data
          .pipe(takeUntil(this.onRouteCheck$))
          .subscribe((data) => {
            this.chouhyouCheck(data);
          })
      });
  }

  protected settingEvent() {
    fromEvent<StorageEvent>(window, 'storage').pipe(
      filter((x: StorageEvent) => x.key === StorageEnum.ALIASTRIGGER || x.key === StorageEnum.SCALE),
      takeUntil(this.onDestory$),
    ).subscribe((data) => {
      try {
        const { newValue, key } = data;
        if (!newValue || newValue === '') return;
        switch (key) {
          case StorageEnum.ALIASTRIGGER: {
            this.aliasSetting(newValue);
            break;
          }
        }
      } catch (error) {
        console.log(error);
        return;
      }
    });
  }

  private aliasSetting(newValue?: string) {
    if (!newValue) {
      this.store.dispatch(new SetAliasId(''));
      return;
    }
    const currentAlias = this.store.selectSnapshot(SettingSelectors.aliasId);
    const newAlias: SettingStateModel = JSON.parse(newValue);
    if (!newAlias.aliasId || newAlias.aliasId === 'null' || newAlias.aliasId === currentAlias) return;
    this.store.dispatch(new SetAliasId(newAlias?.aliasId || ''));
  }

  private chouhyouCheck(data?: any) {
    if (!data['facesheet']) sessionStorage.removeItem('facesheet');
    this.onRouteCheck$.next();
  }

  get landingPage() {
    return sessionStorage.getItem(StorageEnum.LANDING_PAGE) || '';
  }

  private landingPageHandler() {
    //
    switch (this.landingPage) {
      case WebviewLandingHome.HOME_DAILY: {
        this.router.navigate(['webview/home/daily'], { replaceUrl: true });
        break;
      }

      case WebviewLandingHome.MENU: {
        this.router.navigate(['webview'], { replaceUrl: true }).finally(() => {
          this.router.navigate([{ outlets: { modal: 'webview-menu' } }], { replaceUrl: true });
        });
        break;
      }

      case WebviewLandingHome.SCHEDULE_ADD: {
        this.router.navigate(['webview'], { replaceUrl: true }).finally(() => {
          this.router.navigate([{ outlets: { edit: 'webview-schedule-select' } }], { replaceUrl: true });
        });
        break;
      }
    }
  }

  ngOnDestroy(): void {
    this.onDestory$.next();
  }

  private getMenu(menuList: Menu[]) {
    return (url: string) => {
      const menu = menuList.find((menu) =>
        menu.menus.some(
          ({ path }) => path && path !== '' && url.startsWith(path)
        )
      );

      if (menu?.menuGroupName === 'ホーム') {
        return {
          ...menu,
          menus: menu.menus.filter((item) => item.name !== '予定追加'),
        };
      }
      return menu;
    };
  }
}
